import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"

import "./Home.vue?vue&type=style&index=0&id=3ddfaa7d&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/certificate/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddfaa7d"]])

export default __exports__